<script lang="ts">
    import { Col,Accordion, AccordionItem  } from "sveltestrap";
    import { AllCloseAccordion, AllCloseMessage, CollapsibleGroupItem, GroupItem } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" lg="6">
    <Card cardHeader2props="pb-0" >
      <div slot="customHeader2">
        <h5>{AllCloseAccordion}</h5>
        <span>{@html AllCloseMessage}</span>
      </div>
      <div slot="contentbody">
        <Accordion>
          <AccordionItem >
            <h5 class="m-0" slot="header">{CollapsibleGroupItem} <span>1</span></h5>
              {GroupItem}
          </AccordionItem>
          <AccordionItem>
            <h5 class="m-0" slot="header">{CollapsibleGroupItem} <span>2</span></h5>
              {GroupItem}
          </AccordionItem>
          <AccordionItem>
            <h5 class="m-0" slot="header">{CollapsibleGroupItem} <span>3</span></h5>
              {GroupItem}
          </AccordionItem>
          <AccordionItem>
              <h5 class="m-0" slot="header">{CollapsibleGroupItem} <span>4</span></h5>
                {GroupItem}
          </AccordionItem>
          <AccordionItem>
              <h5 class="m-0" slot="header">{CollapsibleGroupItem} <span>5</span></h5>
                {GroupItem}
          </AccordionItem>
        </Accordion>
      </div>
    </Card>
</Col>